import { useEffect, useCallback, useState } from "react";
import { useRegionListRequest, useCountryListRequest, useStoreTypeListRequest, useUserGetPosRequest } from "../../hooks/useApi";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '../Icons/CloseIcon';
import './styles.css';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import UserPos from '../../components/UserPos';
import MainBtn from '../../components/MainBtn';
import TextField from '@mui/material/TextField';
import debounce from 'lodash.debounce';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: "10px",
  boxShadow: 24,
  pt: 2,
  pb: 3,
};

export default function SelectStoreModal({ open, setOpenModal, handleClose, setVisiblePosIds, visiblePosIds }) {
  const [ { loadingRegions }, getRegionList ] = useRegionListRequest();
  const [ { loadingCountries }, getCountriesList ] = useCountryListRequest();
  const [ { loadingStoreTypes }, getStoreTypesList ] = useStoreTypeListRequest();
  const [ { loadingUserPos }, getUserPos ] = useUserGetPosRequest();
  const modalParams = JSON.parse(localStorage.getItem('modalParams'));
  const [selectedRegions, setRegion] = useState(modalParams?.selectedRegions || []);
  const [selectedCountries, setCountry] = useState(modalParams?.selectedCountries || []);
  const [selectedStoreTypes, setStoreType] = useState(modalParams?.selectedStoreTypes || []);
  const [freeText, setFreeText] = useState(null);
  const obj1 = {};
  visiblePosIds.map((vPosId) => {
    obj1[vPosId] = true;
  });
  const [modalPosIds, setModalPosId] = useState(obj1);
  
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);

  const [userPosRows, setUserPosRows] = useState([]);

  const handleChangeRegion = (event) => {
    const { target: { value } } = event;
    setRegion(
      typeof value === 'string' ? value.split(',') : value,
    );
    setCountry([]);
    setStoreType([]);
    setModalPosId({});
  };
  const handleChangeCountry = (event) => {
    const { target: { value } } = event;
    setCountry(
      typeof value === 'string' ? value.split(',') : value,
    );
    setStoreType([]);
    setModalPosId({});
  };
  const handleChangeStoreType = (event) => {
    const { target: { value } } = event;
    setStoreType(
      typeof value === 'string' ? value.split(',') : value,
    );
    setModalPosId({});
  };
  
  const FetchRegionList = useCallback(async () => {
    const aaa = async () => {
      const response = await getRegionList({});
      setRegions(JSON.parse(response.data));
    };
    await aaa();
  }, []);

  const FetchCountriesList = useCallback(async () => {
    const aaa1 = async () => {
      const queryParams = { region: selectedRegions[0] };
      const response = await getCountriesList( {queryParams} );
      setCountries(JSON.parse(response.data));
    };
    await aaa1();
  }, [selectedRegions, setRegion]);

  const FetchStoreTypesList = useCallback(async () => {
    const aaa2 = async () => {
      const queryParams = { region: selectedRegions[0], countryId: selectedCountries[0] };
      const response = await getStoreTypesList( {queryParams} );
      setStoreTypes(JSON.parse(response.data));
    };
    await aaa2();
  }, [selectedCountries, setCountry]);

  const FetchUserPos = useCallback(async () => {
    const aaa3 = async () => {
      if (selectedRegions.length === 0 && selectedCountries.length === 0 && selectedStoreTypes.length === 0)
      {
        setUserPosRows([]);
        return [];
      }
      const bodyParams = {
        virtualStoreIds: selectedRegions,
        countryIds: selectedCountries,
        posTypeIds: selectedStoreTypes,
        freeText: freeText
      };
      const response = await getUserPos( { bodyParams } );
      setUserPosRows(response.data.elements);
    };
    await aaa3();
  });

  useEffect(() => {
    FetchRegionList();
  }, []);

  useEffect(() => {
    FetchCountriesList();
  }, [selectedRegions, setRegion]);

  useEffect(() => {
    FetchStoreTypesList();
  }, [selectedCountries, setCountry]);

  useEffect(() => {
    FetchUserPos();
  }, [selectedStoreTypes, setStoreType, selectedCountries, setCountry, selectedRegions, setRegion]);

  const handleChangePosId = async (event) => {
    const { target: { value, checked } } = event;
    const obj = Object.assign({}, modalPosIds);
    if (checked == false)
    {
      delete obj[value];
      setModalPosId(obj);
    }
    else
      setModalPosId((prevCheckStates) => {
        return { ...prevCheckStates, [value]: true }
      });
  }

  const handleSelectAllPosIds = async (event) => {
    const selectedPosCount = Object.keys(modalPosIds).length;
    const allRowsCount = userPosRows.length;
    
    let obj = {};
    if (selectedPosCount < allRowsCount)
    {
      userPosRows.map((posRow) => {
        obj[posRow.posId] = true;
      });
    }
    
    setModalPosId(obj)
  }

  const debouncedSave = useCallback(
    debounce(async(event, valueToUse) => {
      const { target: { value, name } } = event;
      setFreeText(valueToUse);
      const bodyParams = {
        virtualStoreIds: selectedRegions,
        countryIds: selectedCountries,
        posTypeIds: selectedStoreTypes,
        freeText: valueToUse
      };
      const response = await getUserPos( { bodyParams } );
      setUserPosRows(response.data.elements);
      setModalPosId({});
      
    }, 1500),
    [], // will be created only once initially
  );

  const handleFreeTextChange = async(event) => {
    const { target: { value, name } } = event;
    setFreeText(value);
   
    debouncedSave(event, value);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 720, maxHeight: 821 }}>
          <div className="modalTitle dFlex justifyContentSpaceBetween">
            <h2 className="">Select store</h2>
            <a className='close' onClick={handleClose}>
              <CloseIcon />
            </a>
          </div>
          <hr/>
          <div className="modalBody">
            <div className='grid grid-cols-3 gap-3'>
              <FormControl >
                <InputLabel id="regions-label">Region</InputLabel>
                <Select
                    labelId="regions-label"
                    id="regions"
                    multiple
                    value={selectedRegions}
                    onChange={handleChangeRegion}
                    input={<OutlinedInput label="Region" />}
                    renderValue={(selected) => selected.join(', ')}
                    size="small"
                    sx={{
                      p: 0,
                      fontSize: '14px',
                      color: '#828282',
                      fontFamily: "LatoRegular",
                    }}
                  >
                  {regions.map(({regionId, regionDs}) => (
                    <MenuItem key={regionId} value={regionId}>
                      <Checkbox checked={selectedRegions.includes(regionId)} />
                      <ListItemText primary={regionDs} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl >
                <InputLabel id="nations-label">Nation</InputLabel>
                <Select
                    labelId="nations-label"
                    id="nations"
                    multiple
                    value={selectedCountries}
                    onChange={handleChangeCountry}
                    input={<OutlinedInput label="Nation" />}
                    renderValue={(selected) => selected.join(', ')}
                    size="small"
                    sx={{
                      p: 0,
                      fontSize: '14px',
                      color: '#828282',
                      fontFamily: "LatoRegular",
                    }}
                  >
                  {countries.map(({countryId, countryDs}) => (
                    <MenuItem key={countryId} value={countryId}>
                      <Checkbox checked={selectedCountries.includes(countryId)} />
                      <ListItemText primary={countryDs} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl >
                <InputLabel id="store-types-label">Store type</InputLabel>
                <Select
                    labelId="store-types-label"
                    id="store-types"
                    multiple
                    value={selectedStoreTypes}
                    onChange={handleChangeStoreType}
                    input={<OutlinedInput label="Store type" />}
                    renderValue={(selected) => selected.join(', ')}
                    size="small"
                    sx={{
                      p: 0,
                      fontSize: '14px',
                      color: '#828282',
                      fontFamily: "LatoRegular",
                    }}
                  >
                  {storeTypes.map(({posTypeId, posTypeDs}) => (
                    <MenuItem key={posTypeId} value={posTypeId}>
                      <Checkbox checked={selectedStoreTypes.includes(posTypeId)} />
                      <ListItemText primary={posTypeDs} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className='grid grid-cols-1 gap-3 mt-4'>
              <TextField onChange={handleFreeTextChange} id="outlined-basic" label="Store" variant="outlined" />
            </div>
            <div className="posTableWrapper mt-4">
              {userPosRows.length > 0 && (
                <UserPos
                  rows={userPosRows}
                  modalPosIds={modalPosIds}
                  handleChangePosId={handleChangePosId}
                  handleSelectAllPosIds={handleSelectAllPosIds}
                />)}
            </div>
          </div>
          <hr/>
          <div className="modalFooter">
            <div className="flex place-content-between">
              {Object.keys(modalPosIds).length == 0 && (<>No stores selected</>)}
              {Object.keys(modalPosIds).length == 1 && (<>1 store selected</>)}
              {Object.keys(modalPosIds).length > 1 && (<>{Object.keys(modalPosIds).length} stores selected</>)}
              <div className="flex place-content-between alignItemsCenter">
                <a className="footerCancel" onClick={handleClose}>Cancel</a>
                <MainBtn title="Confirm selected" onClick={()=>{
                  setVisiblePosIds(Object.keys(modalPosIds) || []);
                  localStorage.setItem('modalParams', JSON.stringify({
                    selectedRegions: selectedRegions,
                    selectedCountries: selectedCountries,
                    selectedStoreTypes: selectedStoreTypes,
                    visiblePosIds: Object.keys(modalPosIds) || [],
                  }));
                  setOpenModal(false);
                }} />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}